import axiosInstanceNew from "../lib/axiosinstanceNew";

const InterviewModel = class {

  async List(query = []) {
    return (await axiosInstanceNew.get(`interview?${new URLSearchParams(query)}`)).data;
  }
  async create(data = []) {
    return await axiosInstanceNew.post(`interview`, data);
  }
  async detail(id) {
    return (await axiosInstanceNew.get(`interview/${id}`)).data;
  }
  async update(id, data = []) {
    return await axiosInstanceNew.put(`interview/${id}`, data);
  }
  async delete(id) {
    return await axiosInstanceNew.delete(`interview/${id}`);
  }
}

export default new InterviewModel();